import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';

export class CustomTextService {
  constructor(private loadAllCustomTextCommand: ICommand) {}

  loadCustomText() {
    return this.loadAllCustomTextCommand();
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/services/custom_text_service.ts